import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { SEO } from "../components/SEO";

export function ThankYouPage() {
  return (
    <>
      <SEO
        title="Thank You - Valkyrie Robotics"
        description="Thank you for contacting Valkyrie Robotics. We've received your message and will get back to you soon about our VEX Robotics coaching programs."
        canonical="/thank-you"
        noindex={true}
      />
      <div className="bg-neutral-900 min-h-screen flex items-center justify-center px-4">
        <div className="text-center max-w-2xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            {/* Success Icon */}
            <motion.div
              className="mx-auto w-20 h-20 bg-brand-600 rounded-full flex items-center justify-center mb-8"
              initial={{ scale: 0.8 }}
              animate={{ scale: 1 }}
              transition={{ duration: 0.8, delay: 0.2 }}
            >
              <svg
                className="w-10 h-10 text-neutral-900"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </motion.div>

            {/* Main Message */}
            <motion.h1
              className="text-4xl md:text-5xl font-bold text-white mb-6"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.6, delay: 0.4 }}
            >
              Thank You!
            </motion.h1>

            <motion.p
              className="text-xl text-gray-300 mb-8 leading-relaxed max-w-lg mx-auto"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.6, delay: 0.6 }}
            >
              Your message has been received and we'll get back to you soon
              about our VEX Robotics coaching programs.
            </motion.p>

            {/* Action Buttons */}
            <motion.div
              className="flex flex-col sm:flex-row gap-4 justify-center items-center"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.8 }}
            >
              <Link
                to="/"
                className="inline-flex items-center px-8 py-4 bg-brand-600 text-neutral-900 font-semibold rounded-lg hover:bg-brand-500 transition-all duration-200 hover:scale-105 active:scale-95 shadow-lg"
              >
                <svg
                  className="w-5 h-5 mr-2"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
                  />
                </svg>
                Back to Home
              </Link>

              <Link
                to="/contact"
                className="inline-flex items-center px-8 py-4 border-2 border-neutral-700 text-white font-medium rounded-lg hover:border-neutral-600 hover:bg-neutral-800 transition-all duration-200"
              >
                <svg
                  className="w-5 h-5 mr-2"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z"
                  />
                </svg>
                Contact Us Again
              </Link>
            </motion.div>

            {/* Additional Info */}
            <motion.div
              className="mt-12 pt-8 border-t border-neutral-800"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.6, delay: 1.0 }}
            >
              <p className="text-gray-500 text-sm mb-4">What happens next?</p>
              <div className="text-gray-400 text-sm space-y-2">
                <p>• We'll review your message within 24 hours</p>
                <p>• You'll receive a personalized response from our team</p>
                <p>
                  • We'll answer any questions about our VEX Robotics programs
                </p>
              </div>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </>
  );
}
